import React from 'react';
import { LocalShipping, SettingsBackupRestore, Verified } from '@yme/assets/icons';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { buildKey } from '@yme/utils/common';
import { ProductBenefitStyled, ProductBenefitWrapperStyled, ProductBenefitTextStyled, } from './styled';
export function ProductBenefits({ deliveryInfo, returnInfo, warrantyInfo }) {
    const productBenefitsConfig = [
        {
            icon: LocalShipping,
            text: deliveryInfo,
        },
        {
            icon: SettingsBackupRestore,
            text: returnInfo,
        },
        {
            icon: Verified,
            text: warrantyInfo,
        },
    ];
    return (React.createElement(ProductBenefitWrapperStyled, null, productBenefitsConfig.map(({ icon, text }, index) => text && (React.createElement(ProductBenefitStyled, { key: buildKey(text, index) },
        React.createElement(SVGIcon, { type: icon }),
        React.createElement(ProductBenefitTextStyled, null, text))))));
}
ProductBenefits.displayName = 'ProductBenefits_Component';
